import Error from '../model/Error';
import FollowUpCostConfiguration from '../dto/FollowUpCostConfiguration';
import axios from 'axios';

export default class FollowUpCostConfigurationRepository {
    static findByKindergarten(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/follow-up-costs`)
                .then((response) => resolve(response.data.data.map((data) => FollowUpCostConfiguration.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)))
            ;
        });
    }

    static update(kindergartenId, configurations) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/kindergartens/${kindergartenId}/follow-up-costs`, { followUpCostConfigurations: configurations.map((configuration) => configuration.serialize()) })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
